<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <SGPBotaoVoltarComponent class="mr-3" />
      <h1 class="mdn-Heading mdn-Heading--sm mb-0">
        Novo E-mail Automático
      </h1>
    </div>

    <FormularioEmailAutomaticoComponent
      tipoFormulario="salvar"
      @fechar="voltarParaListagem"
      @criado="irParaEdicao"
    />

    <SGPLoadingComponent v-if="salvandoTemplate" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormularioEmailAutomaticoComponent from '../components/FormularioEmailAutomaticoComponent.vue'

export default {
  name: 'CriarEmailAutomaticoPage',

  components: {
    FormularioEmailAutomaticoComponent
  },

  computed: {
    ...mapGetters('gestaoEmailsAutomaticos', ['salvandoTemplate'])
  },

  methods: {
    voltarParaListagem () {
      this.$router.push({ name: 'gestao-emails-automaticos' })
    },

    irParaEdicao (id) {
      this.$router.push({ name: 'gestao-emails-automaticos-editar', params: { id: String(id) } })
    }
  }
}
</script>
